export interface NumericFormatOptions {
  fractionDigits?: number;
  zeroDisplayCharacter?: "-";
  units?: {
    symbol: string;
    position: "start" | "end";
  };
}

export const formatNumber = (number: number | string, options?: NumericFormatOptions) => {
  const formattedNumber =
    options?.fractionDigits != null
      ? number === 0 && options?.zeroDisplayCharacter != null
        ? options.zeroDisplayCharacter
        : parseFloat(parseFloat(number + "").toFixed(options.fractionDigits)).toLocaleString(undefined, {
            minimumFractionDigits: options.fractionDigits,
            maximumFractionDigits: options.fractionDigits,
          })
      : number === 0 && options?.zeroDisplayCharacter != null
      ? options.zeroDisplayCharacter
      : Math.round(parseFloat(number + "")).toLocaleString();

  return options?.units == null
    ? formattedNumber
    : options.units.position === "start"
    ? options.units.symbol + formattedNumber
    : formattedNumber + options.units.symbol;
};
